export default {"src":"/_next/static/media/email-big.2c58e394.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};